import {
    START_PHONE_VERIFY,
    STOP_OTP_REQUEST,
    POST_REQUEST_OTP,
    POST_VERIFY_OTP,
    VERIFY_PHONE_SLIDER_UNMOUNT,
} from '../actionTypes/PhoneVerificationActionTypes';

export const startPhoneVerification = (sliderStatus = 'REQUEST_OTP', config = {}) => {
    const {
        onPhoneVerificationSuccess = null,
        onPhoneVerificationStop = null,
        phoneNumberWithAlreadyOTP = null,
        isSliderOpen = true,
    } = config;
    return {
        type: START_PHONE_VERIFY,
        payload: {
            isSliderOpen, //  Configure while calling action if slider has to be shown or not. By default, it will be shown
            sliderStatus,
            onPhoneVerificationSuccess,
            onPhoneVerificationStop,
            phoneNumberWithAlreadyOTP,
        },
    };
};

export const stopPhoneVerification = (isSkipTrigger = false) => ({
    type: STOP_OTP_REQUEST,
    isSkipTrigger,
});

export const unmountVerifyPhoneSlider = () => ({ type: VERIFY_PHONE_SLIDER_UNMOUNT });

export const requestOtp = (phoneNumber, isReSendRequest = false) => ({
    type: POST_REQUEST_OTP,
    payload: { phoneNumber, isReSendRequest },
});

export const verifyOtp = (phoneNumber, otp) => ({
    type: POST_VERIFY_OTP,
    payload: { phoneNumber, otp },
});
